// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageJson from '../../package.json';
export const environment = {
    production: false,
    version: packageJson.version,
    configPath: 'config/config.json',
    remoteManifestPath: 'config/remote.manifest.json',
    templateBuilderConfig: 'ram',
    sentryDSN: 'https://6f478a8396ad2f57d015af3d46c8917b@o4505635306405888.ingest.us.sentry.io/4507026900451332',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
